module.exports = __webpack_public_path__ + "img/Best of Australian rot.6c3bbdfb.jpg";